export default __webpack_public_path__ + "static/media/inside-copper-installation.81a0fa60.svg";